/**
 * Drilldown Reading Summary
 * Displays most recent reading of a vital sign or
 * lab result
 */
import React from 'react';

import Icon from '@components/Icon/Icon';

import {
  DateH2,
  FirstCircle,
  LocationDiv,
  SecondCircle,
  Subtext,
  ThirdCircle,
  ValueH2,
  ValueH2Wrapper,
  ValuesWrapper,
} from './DrilldownReadingSummary.style';

const DrilldownReadingSummary: React.FC<{
  value?: string;
  units?: string;
  source?: string | null;
  topText?: React.ReactNode;
  bottomText?: React.ReactNode;
  textSize?: number;
}> = ({
  value = '',
  units = '',
  source = '',
  topText = '',
  bottomText = '',
  textSize = 64,
}) => {
  return (
    <FirstCircle>
      <ValuesWrapper>
        <DateH2>{topText}</DateH2>
        <ValueH2Wrapper>
          <ValueH2 textSize={textSize}>{value || '- -'}</ValueH2>
          <Subtext> {units}</Subtext>
        </ValueH2Wrapper>
        <DateH2>{bottomText}</DateH2>
        {source ? (
          <LocationDiv>
            <Icon
              color="warning.main"
              name="location-dot"
              style={{ marginRight: 5 }}
              type="fas"
            />
            {source}
          </LocationDiv>
        ) : null}
      </ValuesWrapper>

      <SecondCircle />
      <ThirdCircle />
    </FirstCircle>
  );
};

export default DrilldownReadingSummary;
